import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';

import { useLazyAuthVerifyEmployeeCodeQuery } from 'store/apis';
import { setEmployeeCode } from '../../../store/slices';
import { useDispatch } from 'react-redux';

interface UseCodeLoginFormManagerProps {
  zoneId: number;
  next?: (data?: any) => void;
}

export const useCodeLoginFormManager = ({ zoneId, next = () => {} }: UseCodeLoginFormManagerProps) => {
  const [trigger, { isLoading, isSuccess, isError, ...rest }] = useLazyAuthVerifyEmployeeCodeQuery();
  const dispatch = useDispatch();

  const initialValues = {
    code: '',
  };

  const validationSchema = Yup.object({
    code: Yup.string().required('This value is required.'),
  });

  const formManager = useFormik({
    initialValues,
    validationSchema,
    onSubmit: ({ code }, { resetForm }) => {
      dispatch(setEmployeeCode(code));

      resetForm({});

      trigger({
        zoneId,
        code,
      });
    },
  });

  useEffect(() => {
    if (!isLoading && isSuccess && !isError) {
      const { data } = rest;

      next(data);
    }
  }, [isLoading, isSuccess, isError]);

  return [
    {
      formManager,
      loading: isLoading,
      isError,
    },
  ] as [
    {
      formManager: FormikProps<typeof initialValues>;
      loading: boolean;
      isError: boolean;
    },
  ];
};
